import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';

import { Wrapper, WrapperSlide } from './styled';

import Spinner from '../../../../components/Spinner';
import IDHelpers from '../../../../../core/helpers/IDHelper';

interface IProps {
  items?: any[];
}

SwiperCore.use([Navigation, Pagination, Autoplay]);

const HomeCarousel = ({ items }: IProps) => {
  useEffect(() => {
    if (items && items.length > 0) {
      const buttons = document.querySelectorAll<HTMLButtonElement>(
        '.swiper-pagination-bullet'
      );

      buttons.forEach((button) => {
        button.addEventListener('mouseup', (ev) => {
          const target = ev.target as any;
          target.blur();
        });
      });
    }
  }, [items]);

  return (
    <Wrapper data-testid="cmp-home-carousel">
      {items && items.length > 0 ? (
        <Swiper
          autoplay={{ delay: 10000, disableOnInteraction: false }}
          slidesPerView={1}
          preventInteractionOnTransition
          pagination={{ clickable: true, bulletElement: 'button' }}
          loop={items.length > 1}
          navigation={items.length > 1}
        >
          {items.map((v: any) => (
            <SwiperSlide key={IDHelpers.generateID()}>
              <WrapperSlide
                data-testid="cmp-wrapper-slide-button"
                type="button"
                onClick={() => {
                  if (v.urlRef) {
                    window.open(v.urlRef, 'banner', 'noopener');
                  }
                }}
              >
                <img
                  src={
                    v.isDefault
                      ? `data:image/jpg;base64,${v.image}`
                      : v.imageUrl.replace(
                          'https://banner.utpxpedition.com',
                          'https://portal.utp.edu.pe'
                        )
                  }
                  alt={v.urlRef}
                />
              </WrapperSlide>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Spinner />
      )}
    </Wrapper>
  );
};

export default HomeCarousel;
